module.exports = __webpack_public_path__ + "static/media/icon_playground_filter_all.04105e55.svg";